function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5001 5.60839C17.4834 5.60839 17.4584 5.60839 17.4334 5.60839C13.0251 5.16673 8.62505 5.00006 4.26672 5.44173L2.56672 5.60839C2.21672 5.64173 1.90839 5.39173 1.87505 5.04173C1.84172 4.69173 2.09172 4.39173 2.43339 4.35839L4.13339 4.19173C8.56672 3.74173 13.0584 3.91673 17.5584 4.35839C17.9001 4.39173 18.1501 4.70006 18.1167 5.04173C18.0917 5.36673 17.8167 5.60839 17.5001 5.60839Z",
  fill: "#0851B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.08338 4.76675C7.05005 4.76675 7.01672 4.76675 6.97505 4.75841C6.64172 4.70008 6.40838 4.37508 6.46672 4.04175L6.65005 2.95008C6.78338 2.15008 6.96671 1.04175 8.90838 1.04175H11.0917C13.0417 1.04175 13.225 2.19175 13.35 2.95841L13.5334 4.04175C13.5917 4.38341 13.3584 4.70841 13.025 4.75841C12.6834 4.81675 12.3584 4.58341 12.3084 4.25008L12.125 3.16675C12.0084 2.44175 11.9834 2.30008 11.1 2.30008H8.91672C8.03338 2.30008 8.01672 2.41675 7.89172 3.15841L7.70005 4.24175C7.65005 4.55008 7.38338 4.76675 7.08338 4.76675Z",
  fill: "#0851B5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.675 18.9584H7.325C4.41666 18.9584 4.3 17.3501 4.20833 16.0501L3.66666 7.6584C3.64166 7.31673 3.90833 7.01673 4.25 6.99173C4.6 6.97506 4.89166 7.2334 4.91666 7.57506L5.45833 15.9667C5.55 17.2334 5.58333 17.7084 7.325 17.7084H12.675C14.425 17.7084 14.4583 17.2334 14.5417 15.9667L15.0833 7.57506C15.1083 7.2334 15.4083 6.97506 15.75 6.99173C16.0917 7.01673 16.3583 7.3084 16.3333 7.6584L15.7917 16.0501C15.7 17.3501 15.5833 18.9584 12.675 18.9584Z",
  fill: "#0851B5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3833 14.375H8.60828C8.26661 14.375 7.98328 14.0917 7.98328 13.75C7.98328 13.4083 8.26661 13.125 8.60828 13.125H11.3833C11.7249 13.125 12.0083 13.4083 12.0083 13.75C12.0083 14.0917 11.7249 14.375 11.3833 14.375Z",
  fill: "#0851B5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0833 11.0417H7.91663C7.57496 11.0417 7.29163 10.7584 7.29163 10.4167C7.29163 10.0751 7.57496 9.79175 7.91663 9.79175H12.0833C12.425 9.79175 12.7083 10.0751 12.7083 10.4167C12.7083 10.7584 12.425 11.0417 12.0833 11.0417Z",
  fill: "#0851B5"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.0a678ed5.svg";
export { ForwardRef as ReactComponent };